import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { openUploadModal, setOpenServerBrowser } from 'src/features/PixelStreaming/redux/hud';
import { ContentType } from 'src/features/Visitor/components/UploadContentModal/UploadContentModal';

import { usePixelStreamingContext } from '../contexts/PixelStreamingContext';
import useOpenAvatarModal from './useOpenAvatarModal';

export interface OpenModalMessage {
  id: string;
  uploadType: ContentType;
}

export default function useHandlePixelStreamModal() {
  const dispatch = useDispatch();
  const { descriptor } = usePixelStreamingContext();
  const openAvatarModal = useOpenAvatarModal();

  useEffect(() => {
    if (!descriptor) return () => {};
    const listener = ({ id, uploadType }: OpenModalMessage) => {
      switch (id) {
        case 'server-browser':
          dispatch(setOpenServerBrowser(true));
          break;
        case 'upload-content':
          dispatch(openUploadModal(uploadType));
          break;
        case 'customize-avatar':
          openAvatarModal();
          break;
        default:
          break;
      }
    };
    descriptor.on('modal', listener);
    return () => descriptor.off('modal', listener);
  }, [descriptor]);
}
